export default {"src":"/sitetest/_next/static/media/toRegist_active.779ffa19.svg","height":49,"width":49,"blurWidth":0,"blurHeight":0};